(function () {
  'use strict';

  var SEL = {
    appstleOneTimeRadio : '#appstle_selling_plan_label_10',
    appstleSubRadio     : '#appstle_selling_plan_label_20',
    appstleSelect       : '.appstle_subscription_wrapper .appstle_select',
    appstleSubPrice     : '.payAsYouGoPlansDropdownWrapper .appstle_subscription_amount.transcy-money:not(.sr-only)',
    appstleComparePrice : '.payAsYouGoPlansDropdownWrapper .appstle_subscription_compare_amount.transcy-money:not(.sr-only)',
    appstleOnetimePrice : '.appstle_one_time_details_wrapper .appstle_subscription_amount.transcy-money:not(.sr-only)',
    appstleWrapper      : '.appstle_subscription_wrapper',
    themeBlock          : '.s1pr'
  };

  // Track live instances so we can tear down observers on re-init
  var instances = [];

  function destroyFor(root) {
    instances = instances.filter(function (inst) {
      if (inst.root === root || !document.contains(inst.root)) {
        inst.observers.forEach(function (o) { o.disconnect(); });
        inst.timers.forEach(function (t) { clearInterval(t); clearTimeout(t); });
        return false;
      }
      return true;
    });
  }

  //price code start
  var priceInstances = [];

  function destroyPriceFor(root) {
    priceInstances = priceInstances.filter(function (inst) {
      if (inst.root === root || !document.contains(inst.rootEl)) {
        if (inst.changeHandler) inst.changeHandler.target.removeEventListener('change', inst.changeHandler.fn);
        if (inst.observer) inst.observer.disconnect();
        inst.timers.forEach(function (t) { clearTimeout(t); });
        return false;
      }
      return true;
    });
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, window.cwMoneyFormat);
    }
    return '$' + (parseFloat(cents) / 100).toFixed(2);
  }

  window.initCwPriceSync = function (root) {
    root = root || document;
    destroyPriceFor(root);

    var rootEl = (root === document) ? document.documentElement : root;
    var inst = { root: root, rootEl: rootEl, timers: [], observer: null, changeHandler: null };
    priceInstances.push(inst);

    function qs(sel) { return root.querySelector(sel); }

    function waitForAppstleWidget(cb) {
      if (qs('#appstle_subscription_widget0')) { cb(); return; }

      var resolved = false;
      var observer = new MutationObserver(function () {
        if (qs('#appstle_subscription_widget0')) {
          observer.disconnect();
          if (!resolved) { resolved = true; cb(); }
        }
      });
      observer.observe(rootEl, { childList: true, subtree: true });
      inst.observer = observer;

      inst.timers.push(setTimeout(function () {
        if (resolved) return;
        var content = qs('#main-product-content');
        if (content && content.getAttribute('data-selling-plan') === 'onetime') {
          resolved = true;
          observer.disconnect();
          cb();
        }
      }, 3000));

      //rama code for choose specific variant Mago7 test start
      //onload variant change for mago7 only
        const hypothesisId_alt = "01a0fcb9-61a7-7fe1-97f4-4ef1add0338f";
        if (window.shoplift && typeof window.shoplift.isHypothesisActive === "function") 
        {
            // console.log("Shoplift object:", window.shoplift);
            // console.log("isHypothesisActive function:", window.shoplift.isHypothesisActive);
            // console.log("Hypothesis ID being tested:", hypothesisId_alt);

            window.shoplift.isHypothesisActive(hypothesisId_alt).then(active => {
            console.log("AB Test Active Status:", active);
            if (active) 
            {
                //rama ji
                setTimeout(function () { 
                var newWidget = root.querySelector('#cw-sub-widget')
                var templateName = newWidget.dataset.templateName || "";
                if (templateName === 'mago7-new' || templateName === 'mago7-new-v2') {
                    var sizeRadio = root.querySelector('li.f8pr-size-card-item.option-order-30ct input[type="radio"]');
                    if (sizeRadio) {
                    sizeRadio.click();
                    sizeRadio.dispatchEvent(new Event('change', { bubbles: true }));
                    }

                }//if closed
                }, 200);
                //rama
                console.log("version B is active"); 
            } 
            else 
            {
                console.log("Original version A is active"); 
            }
            });
        }// if closed
        else 
        {
            console.warn("Shoplift is not loaded or isHypothesisActive is not available yet.");
        }// else closed
      //rama Mago7 test end

    }//function closed

    function onetimeWidgetPriceUpdate(checkDiscount) {
      inst.timers.push(setTimeout(function () {
        if (!checkDiscount) return;
        var percent = parseFloat(checkDiscount.getAttribute('data-save-percentage')) || 0;
        var price = parseFloat(checkDiscount.getAttribute('data-price')) || 0;
        if (percent <= 0 || price <= 0) return;

        var finalPrice = price - (price * percent / 100);
        var wrap = qs('.appstle_one_time_price_wrapper');
        if (!wrap) return;

        var reg = wrap.querySelector('.appstle_subscription_amount');
        var cmp = wrap.querySelector('.appstle_subscription_amount_compare_at_price');
        if (reg) reg.innerHTML = formatMoney(finalPrice);
        if (cmp) cmp.innerHTML = formatMoney(price);
      }, 100));
    }

    function onetimePriceUpdate(checkDiscount, benefitsBox, applyDiscount) {
      if (benefitsBox) benefitsBox.style.display = 'none';
      if (applyDiscount) applyDiscount.value = 'true';

      var priceWrap = qs('.f8pr-price.product__price');
      if (!priceWrap) return;
      var reg = priceWrap.querySelector('.price-item--regular');
      var cmp = priceWrap.querySelector('.old');

      if (checkDiscount) {
        var percent = parseFloat(checkDiscount.getAttribute('data-save-percentage')) || 0;
        var price = parseFloat(checkDiscount.getAttribute('data-price')) || 0;
        if (percent > 0 && price > 0) {
          var finalPrice = price - (price * percent / 100);
          if (reg) reg.innerHTML = formatMoney(finalPrice);
          if (cmp) cmp.innerHTML = formatMoney(price);

          var wrap = qs('.appstle_one_time_price_wrapper');
          if (wrap) {
            var wReg = wrap.querySelector('.appstle_subscription_amount');
            var wCmp = wrap.querySelector('.appstle_subscription_amount_compare_at_price');
            if (wReg) wReg.innerHTML = formatMoney(finalPrice);
            if (wCmp) wCmp.innerHTML = formatMoney(price);
          }
        }
      } else {
        if (reg) reg.innerHTML = priceWrap.getAttribute('data-price') || '';
        if (cmp) cmp.innerHTML = '';
      }
    }

    function subsPriceUpdate(benefitsBox, applyDiscount) {
      if (benefitsBox) {
        benefitsBox.style.display = benefitsBox.getAttribute('data-sub-display') || 'none';
      }
      if (applyDiscount) applyDiscount.value = 'false';

      var box = qs('.appstle_subscription_amount_wrapper');
      var priceWrap = qs('.f8pr-price.product__price');
      if (!box || !priceWrap) return;

      var reg = box.querySelector('.appstle_subscription_amount');
      var cmp = box.querySelector('.appstle_subscription_compare_amount');
      var target = priceWrap.querySelector('.price-item--regular');
      var targetOld = priceWrap.querySelector('.old');
      if (reg && target) target.innerHTML = reg.innerHTML;
      if (cmp && targetOld) targetOld.innerHTML = cmp.innerHTML;
    }

    waitForAppstleWidget(function () {
      var checkDiscount = qs('[id^="extra_discount_percentage-"]');
      var benefitsBox = qs('.subscription-benefits-content');
      var subOption = qs('#appstle_selling_plan_label_20');
      var oneTimeOption = qs('#appstle_selling_plan_label_10');
      var applyDiscount = qs('#_apply_discount');

      function toggleBenefits() {
        if (subOption && subOption.checked) {
          subsPriceUpdate(benefitsBox, applyDiscount);
          onetimeWidgetPriceUpdate(checkDiscount);
        } else {
          onetimePriceUpdate(checkDiscount, benefitsBox, applyDiscount);
        }
      }

      toggleBenefits();

      var target = (root === document) ? document : rootEl;
      var fn = function (e) {
        if (e.target === subOption) {
          subsPriceUpdate(benefitsBox, applyDiscount);
          onetimeWidgetPriceUpdate(checkDiscount);
        } else if (e.target === oneTimeOption) {
          onetimePriceUpdate(checkDiscount, benefitsBox, applyDiscount);
        }
      };
      target.addEventListener('change', fn);
      inst.changeHandler = { target: target, fn: fn };
    });

    return inst;
  };

  window.addEventListener('themeVariantUpdated', function () {
    var qsPanel = document.getElementById('quickshop');
    var root = (qsPanel && qsPanel.classList.contains('toggle')) ? qsPanel : document;
    setTimeout(function () { window.initCwPriceSync(root); }, 200);
  });

  //price code end

  window.initCwSubWidget = function (root) {
    root = root || document;
    destroyFor(root);

    // console.log("rama rama rama rama");
    var widget = root.querySelector('#cw-sub-widget');
    if (!widget) return null;

    // console.log("rama rama rama rama ji ji ji ji ji");
    var inst = { root: root, observers: [], timers: [] };
    instances.push(inst);

    // ---- everything below is scoped to `root` ----
    var elSubPrice     = root.querySelector('#cw-price-sub');
    var elOrigPrice    = root.querySelector('#cw-price-orig');
    var elOnetimePrice = root.querySelector('#cw-price-onetime');
    var elDelivery     = root.querySelector('#cw-delivery-select');
    var radioSub       = root.querySelector('#cw_subscribe');
    var radioOnetime   = root.querySelector('#cw_onetime');

    var store = { sub: '', orig: '', onetime: '' };

    function qs(sel) { return root.querySelector(sel); }
    function readText(sel) { var el = qs(sel); return el ? el.textContent.trim() : ''; }

    function isValid(str) {
      if (!str) return false;
      var n = parseFloat(str.replace(/[^0-9.]/g, ''));
      return !isNaN(n) && n > 0;
    }
    function setIfValid(el, val) { if (el && isValid(val)) el.textContent = val; }

    function readAllPrices() {
      var sub = readText(SEL.appstleSubPrice);
      var orig = readText(SEL.appstleComparePrice);
      var onetime = readText(SEL.appstleOnetimePrice);
      if (isValid(sub))     store.sub = sub;
      if (isValid(orig))    store.orig = orig;
      if (isValid(onetime)) store.onetime = onetime;
      if (!isValid(store.orig) && isValid(store.onetime)) store.orig = store.onetime;
      if (!isValid(store.onetime) && isValid(store.orig)) store.onetime = store.orig;
    }

    function renderPrices() {
      setIfValid(elSubPrice, store.sub);
      setIfValid(elOrigPrice, store.orig);
      setIfValid(elOnetimePrice, store.onetime);

      var atcPrice    = root.querySelector('#cw-atc-price');
      var atcComPrice = root.querySelector('#cw-atc-cross-price');
      var isSubscribe = radioSub && radioSub.checked;
      if (atcPrice) {
        var p = isSubscribe ? store.sub : store.onetime;
        if (isValid(p)) atcPrice.textContent = p;
        if (isSubscribe && atcComPrice) atcComPrice.textContent = store.onetime;
      }
    }

    function forceSubPriceLoad(cb) {
      var subRadio = qs(SEL.appstleSubRadio);
      var otRadio  = qs(SEL.appstleOneTimeRadio);
      if (!subRadio || !otRadio) { cb(); return; }

      subRadio.click();
      subRadio.dispatchEvent(new Event('change', { bubbles: true }));

      var attempts = 0;
      var poll = setInterval(function () {
        var sub = readText(SEL.appstleSubPrice);
        if (isValid(sub) || ++attempts > 20) {
          clearInterval(poll);
          readAllPrices();
          otRadio.click();
          otRadio.dispatchEvent(new Event('change', { bubbles: true }));
          inst.timers.push(setTimeout(cb, 150));
        }
      }, 100);
      inst.timers.push(poll);
    }

    function fullSync(cb) {
      readAllPrices();
      if (!isValid(store.sub)) {
        forceSubPriceLoad(function () { renderPrices(); if (cb) cb(); });
      } else {
        renderPrices(); if (cb) cb();
      }
    }

    function pollUntilValid(maxMs, cb) {
      var start = Date.now();
      var interval = setInterval(function () {
        readAllPrices();
        if ((isValid(store.sub) && isValid(store.onetime)) || (Date.now() - start) > maxMs) {
          clearInterval(interval);
          renderPrices();
          if (cb) cb();
        }
      }, 120);
      inst.timers.push(interval);
    }

    function clickAppstleRadio(sel) {
      var el = qs(sel);
      if (!el) return;
      el.click();
      el.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function updateActiveCard(isSubscribe) {
      var subCard = widget.querySelector('.cw-option--subscribe');
      var otCard  = widget.querySelector('.cw-option--onetime');
      var atcPrice = root.querySelector('#cw-atc-price');
      var atcComPrice = root.querySelector('#cw-atc-cross-price');

      if (subCard && otCard) {
        subCard.classList.toggle('cw-active', isSubscribe);
        otCard.classList.toggle('cw-active', !isSubscribe);
      }
      if (radioSub)     radioSub.checked = isSubscribe;
      if (radioOnetime) radioOnetime.checked = !isSubscribe;

      if (atcPrice) {
        if (isSubscribe && isValid(store.sub)) {
          atcPrice.textContent = store.sub;
          if (atcComPrice) atcComPrice.textContent = store.onetime;
        } else if (!isSubscribe && isValid(store.onetime)) {
          atcPrice.textContent = store.onetime;
          if (atcComPrice) atcComPrice.textContent = '';
        }
      }
    }

    function applyPurchaseType(isSubscribe) {
      widget.classList.toggle('cw--subscribe', isSubscribe);
      widget.classList.toggle('cw--onetime', !isSubscribe);
      updateActiveCard(isSubscribe);
      clickAppstleRadio(isSubscribe ? SEL.appstleSubRadio : SEL.appstleOneTimeRadio);
      inst.timers.push(setTimeout(function () {
        readAllPrices(); renderPrices(); updateActiveCard(isSubscribe);
      }, 300));
    }

    function syncDelivery(planId) {
      var sel = qs(SEL.appstleSelect);
      if (!sel) return;
      sel.value = planId;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      inst.timers.push(setTimeout(function () { readAllPrices(); renderPrices(); }, 300));
    }

    function syncDeliveryOptions() {

      var appSel = qs(SEL.appstleSelect);
      if (!appSel || !elDelivery) return;
      if (appSel.options.length === elDelivery.options.length) return;

      elDelivery.innerHTML = '';
      Array.from(appSel.options).forEach(function (opt) {
        var o = document.createElement('option');
        o.value = opt.value;
        o.textContent = opt.textContent;
        if (opt.selected) o.selected = true;
        elDelivery.appendChild(o);
      });

    }//function closed

    function observeAppstle() {
      var wrapper = qs(SEL.appstleWrapper);
      if (!wrapper) { inst.timers.push(setTimeout(observeAppstle, 400)); return; }

      var debounce;
      var mo = new MutationObserver(function () {
        clearTimeout(debounce);
        debounce = setTimeout(function () {
          store.sub = '';
          pollUntilValid(2500);
        }, 100);
      });
      mo.observe(wrapper, { childList: true, subtree: true, characterData: true });
      inst.observers.push(mo);

      var themeBlock = qs(SEL.themeBlock);
      if (themeBlock) {
        var themeDebounce;
        var mo2 = new MutationObserver(function () {
          clearTimeout(themeDebounce);
          themeDebounce = setTimeout(function () {
            store.sub = ''; store.onetime = '';
            pollUntilValid(3000);
          }, 150);
        });
        mo2.observe(themeBlock, { childList: true, subtree: true, characterData: true });
        inst.observers.push(mo2);
      }
    }

    radioSub && radioSub.addEventListener('change', function () {
      if (this.checked) applyPurchaseType(true);
    });
    radioOnetime && radioOnetime.addEventListener('change', function () {
      if (this.checked) applyPurchaseType(false);
    });
    elDelivery && elDelivery.addEventListener('change', function () {
      if (radioSub && radioSub.checked) syncDelivery(this.value);
    });

    (function start(attempt) {
      attempt = attempt || 0;
      if (!qs(SEL.appstleWrapper)) {
        if (attempt < 30) inst.timers.push(setTimeout(function () { start(attempt + 1); }, 400));
        else console.warn('[cw-sub-widget] appstle wrapper never appeared in', root);
        return;
      }
      syncDeliveryOptions();
      observeAppstle();
      fullSync(function () { applyPurchaseType(true); });
    })();

    return inst;
  };
})();